module.exports = __webpack_public_path__ + "img/xiaoyuan.a7d6ea17.png";